export const JAPA_LABS_URL = "https://japa.health/labs";
export const JAPA_SEARCH_URL = "https://japa.health/search/";

/** Zoho consent form shown in the Book a Consult pop-up. */
export const BOOK_CONSULT_ZOHO_FORM_URL =
  "https://forms.zohopublic.com/japahealth/form/JapaHealth11ConsultConsentForm/formperma/w1pyB1NIv3RIHsIORj3TevF7-omHZOZZDQ5-lskE3O8";

/**
 * Calendly booking link — reserved for future Mailchimp tag bypass.
 * Override via REACT_APP_BOOK_CONSULT_CALENDLY_URL when wired up.
 */
export const BOOK_CONSULT_CALENDLY_URL =
  process.env.REACT_APP_BOOK_CONSULT_CALENDLY_URL || "";
